import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import { cyan500 } from 'material-ui/styles/colors';
import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';

class PromotionFields extends Component {
  render() {
    const {disableFields, promotion, styles, handleChange, errorText, handleDatePickerChange, handleSelectChange, startDate, 
      endDate, isTrue, salesChannels, nonBuyer, disablePromotion, useOnce, discountId, scSelect, discountSelect, freeShipping  } = this.props;
    return (
      <div>
        <TextField
          floatingLabelText="ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          inputStyle={styles.inputStyle}
          value={promotion.id || ''}
          disabled
        />
        <br />
        <TextField
          floatingLabelText="Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={promotion.name || ''}
          name="name"
          onChange={!disableFields ? handleChange : ''}
          style={styles.inputStyle}
          errorText={errorText.name}
          errorStyle={{ color: cyan500 }}
        />
        <TextField
          floatingLabelText="Description"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={promotion.description || ''}
          name="description"
          onChange={!disableFields? handleChange : ''}
          style={styles.inputStyle}
          errorText={errorText.description}
          errorStyle={{ color: cyan500 }}
        />
        <TextField
          floatingLabelText="Promotion Code"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={promotion.promoCode || ''}
          name="promoCode"
          onChange={!disableFields? handleChange : ''}
          style={styles.inputStyle}
          errorText={errorText.promoCode}
          errorStyle={{ color: cyan500 }}
        />
        <TextField
          floatingLabelText="Maximum Uses"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={promotion.maxUses || ''}
          name="maxUses"
          onChange={!disableFields ? handleChange : ''}
          style={styles.inputStyle}
        />
        <div id="datePickerWrapper">
          <DatePicker
            floatingLabelText="Start Date"
            mode="landscape"
            floatingLabelStyle={styles.floatingLabelStyle}
            hintText="Start Date"
            value={startDate || {}}
            autoOk={isTrue}
            name="startDate"
            onChange={!disableFields ? 
              (e, date) => handleDatePickerChange(e, date, 'startDate')
            : ''}
            style={styles.datePickerStyle}
          />
          <DatePicker
            floatingLabelText="End Date"
            mode="landscape"
            floatingLabelStyle={styles.floatingLabelStyle}
            hintText="End Date"
            value={endDate || {}}
            autoOk={isTrue}
            name="endDate"
            onChange={!disableFields ? 
              (e, date) => handleDatePickerChange(e, date, 'endDate')
            : ''}
            style={styles.datePickerStyle}
          />
          <SelectField
            value={discountId || ''}
            onChange={!disableFields ?
              (event, index, value) => handleSelectChange(event, index, value, 'discountId')
            : ''}
            floatingLabelText="Discount"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="discountId"
            floatingLabelStyle={styles.floatingLabelStyle}
          >
            {discountSelect}
          </SelectField>
          <SelectField
            value={salesChannels || []}
            multiple={isTrue}
            onChange={!disableFields ?
              (event, index, values) => handleSelectChange(event, index, values, 'salesChannels')
            : ''}
            floatingLabelText="Sales Channels"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="salesChannels"
            floatingLabelStyle={styles.floatingLabelStyle}
          >
            <MenuItem checked={salesChannels && salesChannels.includes(0)} value={0} key={0} primaryText="All Sales Channels" />
            {scSelect}
          </SelectField>
        </div>
        <br />
        <br />
        <br />
        <ul>
          <li>
            <Checkbox
              label="Disabled"
              defaultChecked={disablePromotion}
              name="disabled"
              onCheck={!disableFields ? handleChange : ''}
            />
          </li>
          <li>
            <Checkbox
              label="One use limit"
              defaultChecked={useOnce}
              name="useOnce"
              onCheck={!disableFields ? handleChange : ''}
            />
          </li>
          <li>
            <Checkbox
              label="Non buyer"
              defaultChecked={nonBuyer}
              name="nonBuyer"
              onCheck={!disableFields ? handleChange : ''}
            />
          </li>
          <li>
            <Checkbox
              label="Free Shipping"
              defaultChecked={freeShipping}
              name="freeShipping"
              onCheck={!disableFields ? handleChange : ''}
            />
          </li>
        </ul>
      </div>
    )
  }
}

export default PromotionFields;


// WEBPACK FOOTER //
// ./src/components/promotions/PromotionFields.js